import { render, staticRenderFns } from "./FormEmbed.vue?vue&type=template&id=501c6dbc&"
import script from "./FormEmbed.vue?vue&type=script&lang=js&"
export * from "./FormEmbed.vue?vue&type=script&lang=js&"
import style0 from "./FormEmbed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('501c6dbc')) {
      api.createRecord('501c6dbc', component.options)
    } else {
      api.reload('501c6dbc', component.options)
    }
    module.hot.accept("./FormEmbed.vue?vue&type=template&id=501c6dbc&", function () {
      api.rerender('501c6dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/FormEmbed.vue"
export default component.exports